import { render } from "./LineHeight.vue?vue&type=template&id=5c8653da&ts=true"
import script from "./LineHeight.vue?vue&type=script&lang=ts"
export * from "./LineHeight.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__